export const isFileTypeIncluded = (fileType: string, fileTypes: string[]) => {
  return fileTypes
    .map(fileType => (fileType || '').toLowerCase())
    .includes((fileType || '').toLowerCase());
};
